import { formatOrderStatus, normalizeUserRole } from '~/utils';
import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store.ts';

type StatusBadgeSize = 'caption' | 'small';

function getStatusBadgeClassname(status: string, size: StatusBadgeSize) {
  const baseClasses = `px-2 py-1 ${size === 'caption' ? 'text-xs' : 'text-sm'} font-medium rounded-full`;

  switch (status) {
    case 'PENDING_SELLER_CONFIRMATION':
      return `${baseClasses} bg-amber-100 text-amber-600`;
    case 'CONFIRMED':
      return `${baseClasses} bg-blue-100 text-blue-600`;
    case 'SHIPPED':
      return `${baseClasses} bg-purple-100 text-purple-600`;
    case 'DELIVERED':
      return `${baseClasses} bg-green-100 text-green-600`;
    case 'CANCELLED':
      return `${baseClasses} bg-gray-100 text-gray-600`;
    default:
      return `${baseClasses} bg-neut-100 text-neut-400`;
  }
}

export function OrderStatusBadge({
  status,
  size = 'caption',
}: {
  status: string;
  size?: StatusBadgeSize;
}) {
  const rawRole = useSelector((state: RootState) => state.auth.user?.role);
  const role = normalizeUserRole(rawRole);

  return (
    <span className={getStatusBadgeClassname(status, size)}>
      {formatOrderStatus(status, role)}
    </span>
  );
}
